<template>
  <div class="echart">
    <div class="bar" ref="bar"></div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "echarts",
  props: {
    trend: {
      type: Array,
      defalut: {}
    },
    trendTitle: {
      type: String,
      defalut: ""
    }
  },
  data() {
    return {
      dataTime: [], //日期数组
      trendData: [] //趋势图数组
    };
  },
  methods: {
    init() {
      this.getDate(this.trend);
    },
    //时间日期
    getDate(data) {
      this.dataTime = data.map(item => {
        return item.date;
      });
      this.trendData = data.map(item => {
        return item.count;
      });
      setTimeout(() => {
        this.initEcharts();
      }, 300);
    },
    initEcharts() {
      let myEcharts = this.$echarts.init(this.$refs.bar);
      let option = {
        title: {
          text: "打印次数数据趋势",
          x: "left",
          y: "top",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
            color: "#666" // 主标题文字颜色
          }
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            start: 0, //滚动条开始位置（共100等份）
            end: 50, //滚动条结束位置
            zoomLock: false, //控制面板是否进行缩放
            zoomOnMouseWheel: false, //禁止鼠标滚动触发缩放
            moveOnMouseMove: true //触发数据窗口平移
          }
        ],
        grid: {
          top: "10%",
          left: "2%",
          right: "10%",
          bottom: "12%",
          containLabel: true
        },
        //提示框取默认值，即鼠标移动到柱状图会显示内容
        tooltip: {
          trigger: "axis" //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据，
        },
        xAxis: {
          type: "category",
          boundaryGap: false, // 数值起始和结束两端空白策略
          data: this.dataTime,
          //取消刻度卡尺
          axisTick: {
            show: false
          },
          axisLine: {
            // 坐标轴线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: {
              // 属性lineStyle控制线条样式
              color: "#eeeeee",
              width: 2,
              type: "solid"
            }
          },
          axisLabel: {
            // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: "auto",
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: "#999999"
            }
          },
          splitLine: {
            // 分隔线
            show: false // 默认显示，属性show控制显示与否
          },
          splitArea: {
            // 分隔区域
            show: false // 默认不显示，属性show控制显示与否
          }
        },
        yAxis: {
          //设置Y轴坐标
          splitNumber: 10, //分成10份
          min: 0, //最小值
          max: 100, //最大值
          axisLine: {
            // 坐标轴线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: {
              // 属性lineStyle控制线条样式
              color: "#eeeeee",
              width: 2,
              type: "solid"
            }
          },
          axisLabel: {
            // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: "auto",
            rotate: 0,
            margin: 8,
            textStyle: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: "#999999"
            }
          },
          splitLine: {
            // 分隔线
            show: false // 默认显示，属性show控制显示与否
          },
          splitArea: {
            // 分隔区域
            show: false // 默认不显示，属性show控制显示与否
          }
        },
        legend: {},
        series: [
          {
            name: this.trendTitle,
            type: "line",
            stack: "总数",
            showSymbol: false, //拐点图隐藏
            data: this.trendData,
            smooth: true, //设置折线图平滑
            areaStyle: {
              //面积图渐变
              normal: {
                color: {
                  type: "linear", //设置线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#177ae6" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fdfeff" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            }
          }
        ]
      };
      //自适应大小
      myEcharts.setOption(option);
      window.addEventListener("resize", function() {
        myEcharts.resize();
      });
      this.myEcharts = myEcharts;
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    trend(trend) {
      if (!this.myEcharts) return;
      this.myEcharts.setOption({
        series: {
          name: this.trendTitle,
          data: (trend && trend.map(item => item.count)) || []
        },
        xAxis: {
          data: (trend && trend.map(item => item.date)) || []
        },
        title: {
          text: this.trendTitle === "：打印张数"? "打印纸张数据趋势": "打印次数数据趋势",
        }
      });
    }
  }
};
</script>

<style scoped>
.echart {
  display: flex;
}
.bar {
  width: calc(100% - 100px);
  height: 450px;
}
</style>
